import { render, staticRenderFns } from "./idCardInfo.vue?vue&type=template&id=ed31f7f2&scoped=true&"
import script from "./idCardInfo.vue?vue&type=script&lang=js&"
export * from "./idCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./idCardInfo.vue?vue&type=style&index=0&id=ed31f7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed31f7f2",
  null
  
)

export default component.exports